
import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import SearchResultEntity from "../../../../domain/entities/search_result.entity";
import QAAgentEntity from "../../../../domain/entities/qa_agent.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import QAAgentDto from "../../../dto/qa_agent.dto";

const searchAgentsApiImpl = async (_: { query: string, page: number, itemsPerPage: number, operationId?: string }): Promise<Either<ErrorEntity, SearchResultEntity<QAAgentEntity>>> => {
    try {
        const { query, page, itemsPerPage }: { query: string, page: number, itemsPerPage: number } = _;
        let relativeUrl: string = `/agent?page_number=${page}&page_size=${itemsPerPage}&keyword=${query ?? ""}`;
        if (_.operationId && _.operationId !== "") relativeUrl += `&operation_id=${_.operationId}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        const parsed = response.content.map((item: any) => QAAgentDto.fromJSON(item));
        return right({
            data: parsed,
            itemsPerPage: itemsPerPage,
            page: page,
            pages: response.total_pages,
            total: response.total_elements
        })
    } catch (e) {
        return left({ code: "Error" });
    }
}

export default searchAgentsApiImpl;
